import { css } from "@emotion/react";

export const ManagementViewTitle = ({ text }: { text: string }) => {
  return (
    <h1
      css={({ colours, customTypography, breakpoints }) => css`
        opacity: 1;
        color: ${colours.primary.dark._10};
        ${customTypography.jumbo._1}
        text-align: left;
        line-height: 45px;
        width: 100%;
        padding: 0 70px;

        @media (max-width: ${breakpoints.values.xl}px) {
          padding: 0;
        }
      `}
    >
      {text}
    </h1>
  );
};
